import { useSelector } from "react-redux";
import { selectFileName, selectIsolateIds, selectProjectId, selectUrn, selectUrnLatest } from "./selector";

export const useProjectId = () => useSelector(selectProjectId);
export const useUrn = () => useSelector(selectUrn);
export const useUrnLatest = () => useSelector(selectUrnLatest);
export const useFileName = () => useSelector(selectFileName);
export const useIsolateIds = () => useSelector(selectIsolateIds);
